export const baseUrl = "https://solicitud.pacifico.com.pe/seguro-renta-fondo-vida-garantizado";
export const queryParams = new URLSearchParams({
  utm_source: "simuladorfondovidagarantizado",
  utm_medium: "simuladorfondovidagarantizado",
  from: "PAC_RENTAS-FONDO-VIDA-GARANTIZADO-FVG_SIMULADOR-FONDOVIDAGARANTIZADO",
});